import styled from 'styled-components';

export const ServiceWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;

  border-bottom: 1px solid var(--border-color);
  padding: 1em;

  align-items: center;

  &:first-child {
    border-top: 1px solid var(--border-color);
  }
`;

export const ServiceInfo = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
`;

export const ServiceTitle = styled.p`
  color: var(--text-color);
  font-size: 1em;
  font-weight: 600;
  margin: 0 0 0.5rem;
`;

export const ServiceDescription = styled.p`
  color: var(--text-color);
  font-size: 0.8em;
  font-weight: 400;
  margin: 0;
`;

export const CallOut = styled.span`
  color: var(--text-color);
  font-weight: 800;
`;
